// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"fb23d62f","455":"31f21936","977":"ec9a0562"}[chunkId] + ".chunk.js";
};